import {FeatureGatePageWrapper} from '../../limits/feature-gates/feature-gate-page-wrapper';

export function SharedEmailInboxFeatureGatePage() {
    return (
        <FeatureGatePageWrapper
            header='Upgrade to Engagement Pro to use Shared Email Inbox'
            subHeader='Keep team email conversations centralized in one collaborative inbox.'
            bullets={[
                'View and manage shared team email threads in a single workspace.',
                'Collaborate on responses and ownership without leaving the inbox.',
                'Track unassigned, open, and closed conversations across your team.',
                'Use email alongside chat, SMS, and social messaging channels.',
            ]}
            feature='SMS'
        />
    );
}
